/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopNav_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopAppliedFilters_user" | "SbRespRefineTopFilters_user" | "SbRespRefineMenuDrawer_user">;
    readonly " $refType": "SbRespRefineTopNav_user";
};
export type SbRespRefineTopNav_user$data = SbRespRefineTopNav_user;
export type SbRespRefineTopNav_user$key = {
    readonly " $data"?: SbRespRefineTopNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopNav_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopNav_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b4197037e301f58d7d38d722e58d5f14';
export default node;
